import React, { Suspense, useEffect, useState, useRef, FC } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'store/store';
import { LanguageProvider } from './hooks/LanguageProvider';
import { TopicTracked, FeatureTracked } from 'models/tracking';
import { useServiceTracking } from 'components/hooks/tracking/useServiceTracking';
import { LoadingPage } from './common/loading/LoadingPage';
import { AppRoutes } from 'routes';

const App: FC = () => {
    const [showServiceLoader, setShowServiceLoader] = useState<boolean>(true);
    const hasTrackedVisitorRef = useRef(false);
    const { trackAction } = useServiceTracking();
    const { authenticatedUser, isLoading } = useAppSelector(state => ({
        authenticatedUser: state.applicationContext.context?.user,
        isLoading: state.applicationContext.isLoading,
    }), shallowEqual);

    useEffect(() => {
        // Track Visitor
        if (!hasTrackedVisitorRef.current && authenticatedUser) {
            hasTrackedVisitorRef.current = true;
            trackAction(FeatureTracked.Visitor, {
                topic: TopicTracked.Visit,
            });
        }
    }, [authenticatedUser, trackAction]);

    useEffect(() => {
        const timer = setTimeout(() => setShowServiceLoader(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    return <Suspense fallback={<LoadingPage />}>
        {showServiceLoader && <LoadingPage />}
        {!showServiceLoader && !isLoading && <>
            <LanguageProvider />
            <AppRoutes />
        </>}
    </Suspense>;
};

export default App;
